import { ATBeaconButton } from 'components/common/beacon/beaconRegistration';
import React, { useRef } from 'react';
import BaseModal from './BaseModal';

interface ApproximateModalProps {
  opensBy: string;
}

const ApproximateModal: React.FC<ApproximateModalProps> = (props) => {
  const { opensBy } = props;
  const modalRef = useRef<{ close: () => void }>(null);

  const handleClick = () => {
    if (modalRef.current) {
      modalRef.current.close();
    }
  };

  return (
    <BaseModal ref={modalRef} opens-by={opensBy} close-on-click-out={true}>
      <div className="b-flow-space">
        <div className="b-typography-serif--headline--200">
          What does &quot;approximate dollar amount&quot; mean?
        </div>
        <p>
          If you connected to your firm through T. Rowe Price&rsquo;s import service, the
          &quot;approximate dollar amount&quot; listed reflects an approximation of your
          entire account balance at that firm, based on the market value at the time of
          the transfer.
          <br />
          <br />
          If you manually entered your firm information, the &quot;approximate dollar
          amount&quot; listed reflects the approximate dollar amount that you provided.
          <br />
          <br />
          If you made a partial transfer, T. Rowe Price will only transfer the value of
          the assets you indicated, not the total balance reflected on this page.
        </p>
      </div>
      <ATBeaconButton slot="action-zone" onClick={handleClick}>
        Close
      </ATBeaconButton>
    </BaseModal>
  );
};

export default ApproximateModal;
